const STANDARD_TEMPLATE_VARIABLES = [
  { id: 1, text: "Show the proof's name", variable: "proofName" },
  { id: 2, text: "Show the proof's due date", variable: "dueDate" },
  { id: 3, text: 'Show the approval status of the proof. Example: "Waiting" or "Approved"', variable: "proofStatus" },
  { id: 4, text: 'Show the approval status of the current stage. Example: "Waiting" or "2/3 Approvals"', variable: "currentStageStatus" },
  { id: 5, text: "Show the approver's name", variable: "approverName" },
  { id: 6, text: "Show the approver's email", variable: "approverEmail" },
  { id: 7, text: "Show the days the approver will receive reminders", variable: "reminderFrequency" },
  { id: 8, text: "Show the time of day reminders are sent", variable: "timeOfDayToSend" },
  { id: 9, text: "Shows the proof thumbnail image URL", variable: "proofThumbNailUri" },
  { id: 10, text: "Show the URL of the proof review link", variable: "buttonLink" },
  { id: 11, text: "Show the URL of the proof review link button text", variable: "buttonText" },
  { id: 12, text: "Show the shareable approver link for the proof (anyone can review as an approver)", variable: "approverLink" },
  { id: 13, text: "Show the shareable comment-only link for the proof (anyone can comment)", variable: "commentOnlyLink" },
];

class TemplateVariablesService {
  constructor() {
    this.standardVariables = STANDARD_TEMPLATE_VARIABLES;
  }

  getStandardVariables() {
    return [...this.standardVariables];
  }

  async getAll() {
    const variables = this.getStandardVariables();

    try {
      const response = await window.$A.Api.get('/email/template/variables');
      if (response && response.data && response.data.customFieldVariables) {
        const customVars = response.data.customFieldVariables.map((cv, index) => ({
          id: 100 + index,
          text: cv.text,
          variable: cv.variable
        }));
        return [...variables, ...customVars];
      }
    } catch (error) {
      console.error('[TemplateVariablesService] Failed to load custom variables:', error);
    }

    return variables;
  }
}

export default TemplateVariablesService;
